const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
const FETCH_USER_ERROR = 'FETCH_USER_ERROR';
const SHOW_USER_LOADER = 'SHOW_USER_LOADER';
const HIDE_USER_LOADER = 'HIDE_USER_LOADER';
const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
const CREATE_USER_ERROR = 'CREATE_USER_ERROR';
const CREATE_ADMIN_USER_REQUEST = 'CREATE_ADMIN_USER_REQUEST';
const CREATE_ADMIN_USER_SUCCESS = 'CREATE_ADMIN_USER_SUCCESS';
const CREATE_ADMIN_USER_ERROR = 'CREATE_ADMIN_USER_ERROR';
const CREATE_USER_RESET = 'CREATE_USER_RESET';
const UPDATE_USER_RESET = 'UPDATE_USER_RESET';
const GET_USER_ROLES_REQUEST = 'GET_USER_ROLES_REQUEST';
const GET_USER_ROLES_SUCCESS = 'GET_USER_ROLES_SUCCESS';
const GET_USER_ROLES_ERROR = 'GET_USER_ROLES_ERROR';
const FETCH_ENTITY_LIST_REQUEST = 'FETCH_ENTITY_LIST_REQUEST';
const FETCH_ENTITY_LIST_SUCCESS = 'FETCH_ENTITY_LIST_SUCCESS';
const FETCH_ENTITY_LIST_ERROR = 'FETCH_ENTITY_LIST_ERROR';
const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';
const UPDATE_ADMIN_USER_REQUEST = 'UPDATE_ADMIN_USER_REQUEST';
const UPDATE_ADMIN_USER_SUCCESS = 'UPDATE_ADMIN_USER_SUCCESS';
const UPDATE_ADMIN_USER_ERROR = 'UPDATE_ADMIN_USER_ERROR';
const FETCH_USER_MAKER_REQUEST = 'FETCH_USER_MAKER_REQUEST';
const FETCH_USER_MAKERS_SUCCESS = 'FETCH_USER_MAKERS_SUCCESS';
const FETCH_USER_MAKERS_ERROR = 'FETCH_USER_MAKERS_ERROR';

const FETCH_SYSTEM_USERS_REQUEST = 'FETCH_SYSTEM_USERS_REQUEST';
const FETCH_SYSTEM_USERS_SUCCESS = 'FETCH_SYSTEM_USERS_SUCCESS';
const FETCH_SYSTEM_USERS_ERROR = 'FETCH_SYSTEM_USERS_ERROR';

export {
    FETCH_SYSTEM_USERS_REQUEST,
    FETCH_SYSTEM_USERS_SUCCESS,
    FETCH_SYSTEM_USERS_ERROR,
    FETCH_USER_REQUEST,
    FETCH_USER_SUCCESS,
    FETCH_USER_ERROR,
    FETCH_USER_MAKER_REQUEST,
    FETCH_USER_MAKERS_SUCCESS,
    FETCH_USER_MAKERS_ERROR,
    HIDE_USER_LOADER,
    SHOW_USER_LOADER,
    CREATE_USER_REQUEST,
    CREATE_USER_SUCCESS,
    CREATE_USER_ERROR,
    CREATE_USER_RESET,
    GET_USER_ROLES_SUCCESS,
    GET_USER_ROLES_REQUEST,
    GET_USER_ROLES_ERROR,
    FETCH_ENTITY_LIST_REQUEST,
    FETCH_ENTITY_LIST_SUCCESS,
    FETCH_ENTITY_LIST_ERROR,
    UPDATE_USER_REQUEST,
    UPDATE_USER_SUCCESS,
    UPDATE_USER_ERROR,
    CREATE_ADMIN_USER_REQUEST,
    CREATE_ADMIN_USER_SUCCESS,
    CREATE_ADMIN_USER_ERROR,
    UPDATE_ADMIN_USER_REQUEST,
    UPDATE_ADMIN_USER_SUCCESS,
    UPDATE_ADMIN_USER_ERROR,
    UPDATE_USER_RESET,
};
